export default __webpack_public_path__ + "static/media/cloudwatch-config.7e466757.svg";